import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://api.strikeaprice.com/prod";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    console.log(
      `Making ${config.method?.toUpperCase()} request to ${config.url}`
    );
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("API Error:", error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const contactAPI = {
  submit: async (contactData) => {
    try {
      const response = await api.post("/contact", contactData);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error || "Failed to submit contact form"
      );
    }
  },
};

export const trialAPI = {
  signup: async (trialData) => {
    try {
      const response = await api.post("/trial", trialData);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error || "Failed to create trial account"
      );
    }
  },
};

export default api;
